<script lang="ts">
  import type { Snippet } from 'svelte';
  import { cn } from '../../lib/utils/cn';

  interface Props {
    open?: boolean;
    title: string;
    side?: 'left' | 'right';
    class?: string;
    onclose?: () => void;
    children?: Snippet;
  }

  let {
    open = $bindable(false),
    title,
    side = 'right',
    class: className = '',
    onclose,
    children,
  }: Props = $props();

  function close() {
    open = false;
    onclose?.();
  }

  function handleKeydown(event: KeyboardEvent) {
    if (event.key === 'Escape' && open) {
      event.preventDefault();
      close();
    }
  }
</script>

<svelte:window onkeydown={handleKeydown} />

{#if open}
  <div class="pointer-events-auto fixed inset-0 z-50 flex" role="presentation">
    <button
      type="button"
      class="absolute inset-0 bg-[rgba(13,58,36,0.45)]"
      aria-label="Close drawer"
      onclick={close}
    ></button>
    <div
      class={cn(
        'relative z-10 flex h-full w-full max-w-sm flex-col border border-[var(--tx42-panel-border-subtle)] bg-tx42-panel text-tx42-text shadow-tx42-panel motion-safe:transition-transform motion-safe:duration-300',
        side === 'left' ? 'mr-auto' : 'ml-auto',
        className,
      )}
      role="dialog"
      aria-modal="true"
      aria-labelledby="drawer-title"
    >
      <header class="flex items-center justify-between border-b border-[var(--tx42-panel-border-subtle)] px-4 py-3">
        <h2 id="drawer-title" class="text-lg font-semibold text-tx42-text">{title}</h2>
        <button
          type="button"
          class="tx42-interactive rounded-full px-3 py-1 text-sm font-semibold text-tx42-text-muted hover:bg-[var(--tx42-team-us-muted)]"
          onclick={close}
        >
          Close
        </button>
      </header>
      <div class="flex-1 overflow-y-auto p-4">
        {#if children}
          {@render children()}
        {/if}
      </div>
    </div>
  </div>
{/if}
